import { DRAG_EVENT_KEY } from '../constants/folders';
export function isFoldersDragItemEvent(e) {
  if (!e || !e.dataTransfer || !e.dataTransfer.items || typeof e.dataTransfer.items[Symbol.iterator] !== 'function') {
    return false;
  }
  for (const item of e.dataTransfer.items) {
    // all dataTransferItem types are converted to lowercase
    // https://html.spec.whatwg.org/multipage/dnd.html#the-drag-data-store
    if (item.type === DRAG_EVENT_KEY.toLowerCase() && item.kind === 'string') {
      return true;
    }
  }
  return false;
}